var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OmitType } from "@nestjs/swagger";
import { Type } from "class-transformer";
import { IsArray, IsBoolean, IsDate, IsEnum, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
export var BlockchainSigningType;
(function (BlockchainSigningType) {
    BlockchainSigningType["OPERATIONAL_ACCOUNT"] = "OPERATIONAL_ACCOUNT";
    BlockchainSigningType["SIGNING_APP"] = "SIGNING_APP";
})(BlockchainSigningType || (BlockchainSigningType = {}));
export class BlockchainBackendConfigDto {
}
__decorate([
    IsEnum(BlockchainSigningType),
    __metadata("design:type", String)
], BlockchainBackendConfigDto.prototype, "signingType", void 0);
export class BlockchainTransactionResultDto {
}
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Object)
], BlockchainTransactionResultDto.prototype, "blockNumber", void 0);
export var BlockchainTransactionType;
(function (BlockchainTransactionType) {
    BlockchainTransactionType["SUBMIT_STUDY"] = "SUBMIT_STUDY";
    BlockchainTransactionType["APPROVE_STUDY"] = "APPROVE_STUDY";
    BlockchainTransactionType["REJECT_STUDY"] = "REJECT_STUDY";
    BlockchainTransactionType["PRESCREEN_CONSENT_LEDGER_RECORDS"] = "PRESCREEN_CONSENT_LEDGER_RECORDS";
    BlockchainTransactionType["ENROLLMENT_CONSENT_LEDGER_RECORDS"] = "ENROLLMENT_CONSENT_LEDGER_RECORDS";
    BlockchainTransactionType["EDIT_ORGANIZATION"] = "EDIT_ORGANIZATION";
    BlockchainTransactionType["EDIT_USER"] = "EDIT_USER";
})(BlockchainTransactionType || (BlockchainTransactionType = {}));
export var BlockchainTransactionStatus;
(function (BlockchainTransactionStatus) {
    BlockchainTransactionStatus["PENDING"] = "PENDING";
    BlockchainTransactionStatus["NOTIFICATION_RECEIVED"] = "NOTIFICATION_RECEIVED";
    BlockchainTransactionStatus["SENDING_TRANSACTION"] = "SENDING_TRANSACTION";
    BlockchainTransactionStatus["MINING_TRANSACTION"] = "MINING_TRANSACTION";
    BlockchainTransactionStatus["SYNCING_BACKEND"] = "SYNCING_BACKEND";
    BlockchainTransactionStatus["DECLINED"] = "DECLINED";
    BlockchainTransactionStatus["EXPIRED"] = "EXPIRED";
    BlockchainTransactionStatus["COMPLETED"] = "COMPLETED";
    BlockchainTransactionStatus["FAILED"] = "FAILED";
})(BlockchainTransactionStatus || (BlockchainTransactionStatus = {}));
export const isBlockchainTransactionYetToStart = {
    PENDING: true,
    NOTIFICATION_RECEIVED: true,
    SENDING_TRANSACTION: false,
    MINING_TRANSACTION: false,
    SYNCING_BACKEND: false,
    DECLINED: false,
    EXPIRED: false,
    COMPLETED: false,
    FAILED: false,
};
export const isBlockchainTransactionInProgress = {
    PENDING: false,
    NOTIFICATION_RECEIVED: false,
    SENDING_TRANSACTION: true,
    MINING_TRANSACTION: true,
    SYNCING_BACKEND: true,
    DECLINED: false,
    EXPIRED: false,
    COMPLETED: false,
    FAILED: false,
};
export const isBlockchainTransactionComplete = {
    PENDING: false,
    NOTIFICATION_RECEIVED: false,
    SENDING_TRANSACTION: false,
    MINING_TRANSACTION: false,
    SYNCING_BACKEND: false,
    DECLINED: true,
    EXPIRED: true,
    COMPLETED: true,
    FAILED: true,
};
export class BlockchainTransactionMetadataDto {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], BlockchainTransactionMetadataDto.prototype, "transactionId", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Date)
], BlockchainTransactionMetadataDto.prototype, "createdAt", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Date)
], BlockchainTransactionMetadataDto.prototype, "expiresAt", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], BlockchainTransactionMetadataDto.prototype, "request", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], BlockchainTransactionMetadataDto.prototype, "action", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], BlockchainTransactionMetadataDto.prototype, "studyName", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], BlockchainTransactionMetadataDto.prototype, "requestor", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], BlockchainTransactionMetadataDto.prototype, "patientInfo", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], BlockchainTransactionMetadataDto.prototype, "user", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], BlockchainTransactionMetadataDto.prototype, "confirmButton", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], BlockchainTransactionMetadataDto.prototype, "denyButton", void 0);
export class BlockchainTransactionDto {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], BlockchainTransactionDto.prototype, "id", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Date)
], BlockchainTransactionDto.prototype, "createdAt", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], BlockchainTransactionDto.prototype, "userId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], BlockchainTransactionDto.prototype, "to", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], BlockchainTransactionDto.prototype, "data", void 0);
__decorate([
    Type(() => BlockchainTransactionMetadataDto),
    ValidateNested(),
    __metadata("design:type", BlockchainTransactionMetadataDto)
], BlockchainTransactionDto.prototype, "metadata", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], BlockchainTransactionDto.prototype, "currentStatus", void 0);
export class BlockchainTransactionArrayDto {
}
__decorate([
    Type(() => BlockchainTransactionDto),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], BlockchainTransactionArrayDto.prototype, "transactions", void 0);
export class BlockchainTransactionResponseDto {
}
__decorate([
    Type(() => BlockchainTransactionDto),
    ValidateNested(),
    IsOptional(),
    __metadata("design:type", BlockchainTransactionDto)
], BlockchainTransactionResponseDto.prototype, "transactionToWaitOn", void 0);
export class PortalUserFullInfoDto {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], PortalUserFullInfoDto.prototype, "clientId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], PortalUserFullInfoDto.prototype, "clientSessionToken", void 0);
__decorate([
    IsString({ each: true }),
    __metadata("design:type", Array)
], PortalUserFullInfoDto.prototype, "backups", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], PortalUserFullInfoDto.prototype, "isAccountAbstracted", void 0);
export class CreatePortalInfoInput {
}
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], CreatePortalInfoInput.prototype, "isAccountAbstracted", void 0);
export class PortalUserInfoDto extends OmitType(PortalUserFullInfoDto, ["backups"]) {
}
export class PortalUserInfoWithoutTokenDto extends OmitType(PortalUserFullInfoDto, ["clientSessionToken"]) {
}
export class BlockchainUpdateStatusInput {
}
__decorate([
    IsEnum(BlockchainTransactionStatus),
    __metadata("design:type", String)
], BlockchainUpdateStatusInput.prototype, "status", void 0);
export class UpdatePortalInfoInput {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], UpdatePortalInfoInput.prototype, "onChainAddress", void 0);
export var PortalBackupType;
(function (PortalBackupType) {
    PortalBackupType["GDRIVE"] = "GDRIVE";
    PortalBackupType["ICLOUD"] = "ICLOUD";
    PortalBackupType["PASSWORD"] = "PASSWORD";
    PortalBackupType["PASSKEY"] = "PASSKEY";
})(PortalBackupType || (PortalBackupType = {}));
export class PortalServiceCreateBackupInput {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], PortalServiceCreateBackupInput.prototype, "clientId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], PortalServiceCreateBackupInput.prototype, "share", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], PortalServiceCreateBackupInput.prototype, "backupMethod", void 0);
export class PortalServiceFetchBackupInput {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], PortalServiceFetchBackupInput.prototype, "clientId", void 0);
export class PortalServiceFetchBackupDto {
}
__decorate([
    IsArray(),
    __metadata("design:type", Array)
], PortalServiceFetchBackupDto.prototype, "backupShares", void 0);
export class PortalUserCreateBackupInput {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], PortalUserCreateBackupInput.prototype, "cipherText", void 0);
__decorate([
    IsEnum(PortalBackupType),
    __metadata("design:type", String)
], PortalUserCreateBackupInput.prototype, "backupMethod", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], PortalUserCreateBackupInput.prototype, "platform", void 0);
export class PortalUserFetchBackupInput {
}
__decorate([
    IsEnum(PortalBackupType),
    __metadata("design:type", String)
], PortalUserFetchBackupInput.prototype, "backupMethod", void 0);
export class PortalUserFetchBackupDto {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], PortalUserFetchBackupDto.prototype, "cipherText", void 0);
__decorate([
    IsDate(),
    Type(() => Date),
    __metadata("design:type", Date)
], PortalUserFetchBackupDto.prototype, "createdAt", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], PortalUserFetchBackupDto.prototype, "platform", void 0);
